import type { ReactNode } from 'react';
import type { PersonaProfile, PersonaRoute } from './types';

/**
 * Ren vy-resolver: returnerar personans override-vy för en route om den finns,
 * annars fallback. Exporteras ren och testbar (inga hooks).
 *
 * Iteration 1: teen har views={} → alltid fallback (de ärvda barn-vyerna).
 */
export const resolveView = (
  profile: PersonaProfile,
  route: PersonaRoute,
  fallback: () => ReactNode,
): (() => ReactNode) => profile.views[route] ?? fallback;
